import {gql,TypedDocumentNode} from '@apollo/client';

interface Result {
    id: string,
    title: string,
}

export type UploadStageFile = {title: string, type: 'pdf' | 'image'}

interface Variables {
    input: {
        description: string,
        files: UploadStageFile[],
        title: string,
    }
}

export const CREATE_UPLOAD_STAGE: TypedDocumentNode<Result, Variables> = gql`
    mutation CreateUploadStage($input: UploadStageInput){
        createUploadStage(input: $input) {
            id
            title
        }
    }       
`
